// extracted by mini-css-extract-plugin
export default {"formError":"FormErrors_formError__eHBJ+"};